import styled from 'styled-components';
import { NeutralBanner } from 'ui/banner';
import { BUTTON_SIZES, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { spacing } from 'ui/theme';
import { ModalType, useModalContext } from '../../context';
import { useActivateCampaign } from './useActivateCampaign';

const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  padding: 0 ${spacing.plusHalf};
`;

export const ACTIVATE_CAMPAIGN_MODAL_TEST_ID = 'activate-campaign-modal';
export const ACTIVATE_CAMPAIGN_BUTTON_TEST_ID = 'activate-campaign-button';

export const ACTIVATE_CAMPAIGN_BANNER_MESSAGE =
  'User-initiated templates will only be sent if a recipient has contacted your business within the last 24 hours.';

type Props = { isWhatsApp?: boolean; isUserInitiatedType?: boolean };

export const ActivateCampaignModal = ({
  isWhatsApp = false,
  isUserInitiatedType = false,
}: Props) => {
  const { closeModal } = useModalContext();
  const { isLoading, activateCampaign } = useActivateCampaign();

  const handleConfirm = () => {
    activateCampaign();
  };

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.ActivateCampaignModal)}
      id="activate-modal"
      data-test={ACTIVATE_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Activate campaign?</ModalHeader>
      <StyledModalBody>
        This campaign will be activated immediately.
        {isWhatsApp && isUserInitiatedType && (
          <NeutralBanner>{ACTIVATE_CAMPAIGN_BANNER_MESSAGE}</NeutralBanner>
        )}
      </StyledModalBody>
      <ModalFooter>
        <Button
          data-test={ACTIVATE_CAMPAIGN_BUTTON_TEST_ID}
          onClick={handleConfirm}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Activate campaign
        </Button>
      </ModalFooter>
    </Modal>
  );
};
